import * as React from "react";
import {match, Redirect, Route, Switch, withRouter} from "react-router";
import RestrictedRoute from "./route/RestrictedRoute";
import {UserPermission} from "../model/user/UserPermission";
import JobDetails from "../components/job/details/JobDetails";
import CreateJob from "../components/job/CreateJob";
import EvChargingBillPage from "../components/evCharging/EvChargingBillPage";
import JobUuidRouteComponent from "../components/job/details/JobUuidRouteComponent";
import InvoiceDetails from "../components/accounting/invoiceDetails/InvoiceDetails";
import QuoteDetailsView from "../components/quote/QuoteDetailsView";
import JobWorkspaceContainer from "../components/v5/workspace/JobWorkspaceContainer";
import JobBillOfMaterials from "../components/job/billOfMaterials/JobBillOfMaterials";
import JobBillOfMaterialsDetails from "../components/job/billOfMaterials/details/JobBillOfMaterialsDetails";
import MerchantBillOfMaterialPreview from "../components/job/billOfMaterials/details/MerchantBillOfMaterialPreview";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 * Job router view.
 */
export default class JobRouter extends React.PureComponent <RouteProps, {}> {

	//TODO add new permissions for jobs
	render() {
		return (
			<Switch>
				<Route exact path={this.props.match.url} component={JobWorkspaceContainer}/>
				<RestrictedRoute path={this.props.match.url + "/create"}
								 component={CreateJob}
								 exact
								 allowedPermissions={[UserPermission.LeadCreate]}/>
				{/* admin only, like the backend: it records energy claimed for credits */}
				<RestrictedRoute path={this.props.match.url + "/ev-charging/create"}
								 component={EvChargingBillPage}
								 exact
								 allowedPermissions={[UserPermission.AdminAll]}/>
				<RestrictedRoute path={this.props.match.url +
				"/:jobId([0-9a-fA-F]{8}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{12})"}
								 component={JobUuidRouteComponent}
								 exact
								 allowedPermissions={[UserPermission.LeadEdit, UserPermission.LeadView]}/>
				<RestrictedRoute path={this.props.match.url + "/:jobReferenceNumber/invoice"}
								 component={InvoiceDetails}
								 exact
								 allowedPermissions={[UserPermission.LeadEdit, UserPermission.LeadView]}/>
				<RestrictedRoute path={this.props.match.url + "/:jobReferenceNumber/billofmaterials"}
								 component={JobBillOfMaterials}
								 exact
								 allowedPermissions={[UserPermission.LeadEdit, UserPermission.LeadView]}/>
				<RestrictedRoute path={this.props.match.url + "/:jobReferenceNumber/billofmaterials/merchants/:merchantId"}
								 component={withRouter(MerchantBillOfMaterialPreview)}
								 exact
								 allowedPermissions={[UserPermission.LeadEdit, UserPermission.LeadView]}/>
				<RestrictedRoute path={this.props.match.url + "/:jobReferenceNumber/billofmaterials/:bomId"}
								 component={withRouter(JobBillOfMaterialsDetails)}
								 exact
								 allowedPermissions={[UserPermission.LeadEdit, UserPermission.LeadView]}/>
				<RestrictedRoute path={this.props.match.url + "/:jobReferenceNumber"}
								 component={JobDetails}
								 exact
								 allowedPermissions={[UserPermission.LeadEdit, UserPermission.LeadView]}/>
				<RestrictedRoute exact
								 path={this.props.match.url + "/:jobReferenceNumber/quotes/:quoteId"}
								 component={QuoteDetailsView}
								 allowedPermissions={[UserPermission.LeadView]}/>
				<Redirect to={this.props.match.url}/>
			</Switch>
		)
	}
}
